import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { getDateTimeObject } from "../../../utils/helpers/human-readable-date-parser";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { ORDER_STATUS } from "../my-order-summary-status/selector";

const MyOrderCardV2 = ({
    details = {},
    handleOnClick,
    isDesktop = false
}) => {
    const {
        orderNumber = "",
        createdAt,
        netAmount,
        orderItems,
        status,
        orderId = ""
    } = details || {};

    const getParsedDate = () => {
        const { day, month, year } = getDateTimeObject(createdAt, true);
        return `${day} ${month} ${year}`;
    };

    return (
        <div styleName={`styles.myOrderCardWrapper ${isDesktop ? "styles.myOrderCardDesktopWrapper" : ""}`}>
            <div styleName={`styles.myOrderCard`}>
                <div styleName={`styles.transactionNo ${isDesktop ? "styles.desktopTransactionNo" : ""}`}>
                    <div>
                        <small>Transaction ID</small>
                        <span>{orderId}</span>
                    </div>
                    <div styleName={"styles.date"}>
                        <small>Paid Date</small>
                        <span>{getParsedDate()}</span>
                    </div>
                </div>

                <div styleName={`styles.totalAmount ${(status === ORDER_STATUS.PAYMENT_SUCCESS || status === ORDER_STATUS.SENT_FOR_FULFILLMENT) ? "styles.paidAmount" : ""} ${isDesktop ? "styles.desktopTotalAmount" : ""}`}>
                    <h3>
                        Total Amount
                    </h3>
                    <span>₹{priceFormatter(netAmount)}</span>
                </div>

                <div styleName={`styles.challanCount ${isDesktop ? "styles.desktopChallanCount" : ""}`}>
                    {orderItems.length} Challan{orderItems.length > 1 && "s"}
                </div>

                <div styleName={"styles.orderSummaryCta"} onClick={() => handleOnClick({ orderNumber })}>
                    Order Summary
                </div>
            </div>
        </div>
    );
};

MyOrderCardV2.propTypes = {
    details: PropTypes.object,
    handleOnClick: PropTypes.func,
    isDesktop: PropTypes.bool
};

export default MyOrderCardV2;

